import { getCookieConsentValue } from "react-cookie-consent";

const INSIGHT_SCRIPT_URL = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

/** Same partner id as LinkedIn Campaign Manager / embed snippet. */
export const LINKEDIN_INSIGHT_PARTNER_ID = "10147921";

/**
 * Optional Campaign Manager conversion rule IDs per GA event name (`gtag('event', …)`).
 * Fill when you want `lintrk` to mirror those flash events; leave empty to skip (Insight base tag still loads).
 */
const LINKEDIN_CONVERSION_IDS = {
  CompleteRegistration: "",
  CompleteOnboarding: "",
  CreateWorkspace: "",
};

/**
 * Official LinkedIn Insight Tag bootstrap (browser only).
 *
 * @param {{ partner_id: string }} tracking
 */
export function injectLinkedInInsightTag(tracking) {
  const partnerId = tracking && tracking.partner_id;
  if (!partnerId || typeof document === "undefined") return;

  if (document.querySelector("script[data-linkedin-insight]")) return;

  window._linkedin_partner_id = partnerId;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  if (!window._linkedin_data_partner_ids.includes(partnerId)) {
    window._linkedin_data_partner_ids.push(partnerId);
  }

  (function (l) {
    if (!l) {
      window.lintrk = function (a, b) {
        window.lintrk.q.push([a, b]);
      };
      window.lintrk.q = [];
    }
    var b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = INSIGHT_SCRIPT_URL;
    b.setAttribute("data-linkedin-insight", "1");
    var s = document.getElementsByTagName("script")[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(b, s);
    } else {
      (document.head || document.documentElement).appendChild(b);
    }
  })(window.lintrk);
}

export function trackLinkedInConversion(conversionId) {
  if (!conversionId) return;
  if (typeof window.lintrk === "function") {
    window.lintrk("track", { conversion_id: conversionId });
  }
}

/** Same flash events as `gtag('event', gaEventName)`. */
export function trackLinkedInConversionForGaEvent(gaEventName) {
  if (typeof window === "undefined" || getCookieConsentValue() !== "true") return;
  const id = LINKEDIN_CONVERSION_IDS[gaEventName];
  if (!id) return;
  injectLinkedInInsightTag({ partner_id: LINKEDIN_INSIGHT_PARTNER_ID });
  trackLinkedInConversion(id);
}
